import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { globalStore } from '../../../../modules/shared/shared.global-service';
import {
    selectCurrentServiceId,
    selectCurrentServiceSettings,
} from '../../../../modules/content/store/person/person.selectors';
import {
    SERVICE_SETTINGS_FOLDER_PERSONS_DEFAULT,
    SERVICE_SETTINGS_FOLDER_PERSONS_KEY,
    ServiceSettingsFolderPersonsType,
} from '@libs/types/src/services/types/service-settings-folder-persons.type';

@Injectable()
export class FolderPersonsStore extends ComponentStoreV2Factory {

    public currentServiceId = globalStore!.selectSignal(selectCurrentServiceId);

    private rawSettings = globalStore!.selectSignal(selectCurrentServiceSettings(
        SERVICE_SETTINGS_FOLDER_PERSONS_KEY,
        SERVICE_SETTINGS_FOLDER_PERSONS_DEFAULT,
    ));

    public settings = computed<ServiceSettingsFolderPersonsType>(() => this.rawSettings());

}
